import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";

export const DialogYesNoCancel = ({
  message,
  message2,
  message3,
  showNo,
  showCancel,
  yesTitle,
  noTitle,
  cancelTitle,
  yesEvent,
  noEvent,
  cancelEvent
}) => {
 
  return (
    <S.Container onClick={cancelEvent}>
      <S.Wrapper onClick={(event) => event.stopPropagation()}>
        <S.TitleBar>
          {showCancel && <S.Close onClick={cancelEvent}>×</S.Close>}
        </S.TitleBar>
        <S.Content>
          <h4>{message}</h4>
          <div>
            <small>
              <strong>{message2}</strong>
              <br />
              <strong>{message3}</strong>
            </small>
          </div>

          <S.Buttons>
            <button onClick={yesEvent}>
              {yesTitle ?? 'Si'}
            </button>

            {showNo && <button onClick={noEvent}>{noTitle ?? 'No'}</button>}
            {showCancel && <button onClick={cancelEvent}>{ cancelTitle ?? 'Cancelar'}</button>}
          </S.Buttons>
        </S.Content>
      </S.Wrapper>
    </S.Container>
  );
};

DialogYesNoCancel.propTypes = {
  message: PropTypes.string.isRequired,
  yesEvent: PropTypes.func.isRequired,
};
